module.exports = __webpack_public_path__ + "static/media/aboutimg.37071109.png";